export default {
  slug: "dental-braces-in-guwahati",
  title: "Dental Braces and Aligners in Guwahati",
  subtitle:
    "Straighten Your Smile with Confidence - Advanced orthodontic solutions for a confident, healthy, and well-aligned smile",
  heroImage: "/dental-services/braces-aligners/orthodontic-treatment-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Dental Braces and Aligners in Guwahati",
      content: `
A straight, well-aligned smile not only looks beautiful but also improves your overall oral health. At Magnum Dental Clinic, Guwahati, we offer advanced dental braces and clear aligners to help you achieve a confident, healthy smile—comfortably and effectively.

Whether you have crooked teeth, gaps, crowding, or bite issues, our customized orthodontic treatments are designed for patients of all ages.
      `,
    },
{
      type: "image",
      images: [
        "/dental-services/braces-aligners.webp",
        "/dental-services/braces-aligners/best-braces-treatment-in-guwahati.webp",
        "/dental-services/braces-aligners/best-braces-in-guwahati.webp",
        "/dental-services/braces-aligners/best-orthodontist-in-guwahati.webp",
      ],
      caption: "Images are for illustrative  purposes only",
    },
    {
      type: "text",
      heading: "What Are Dental Braces?",
      content: `
Dental braces are orthodontic devices that gradually move teeth into proper alignment using brackets, wires, and gentle pressure over time. They are highly effective for correcting complex alignment and bite problems.

**Types of Braces We Offer:**
✔ Metal Braces – Strong, effective, and budget-friendly  
✔ Ceramic Braces – Tooth-colored and less noticeable  
✔ Self-Ligating Braces – Faster treatment with less discomfort  
✔ Clear Aligners
      `,
    },

    {
      type: "text",
      heading: "What Are Clear Aligners?",
      content: `
Clear aligners are transparent, removable trays that gently straighten your teeth without wires or brackets. They are custom-made using advanced digital technology.

**Benefits of Clear Aligners:**
✔ Virtually invisible  
✔ Comfortable and removable  
✔ Easy to clean and maintain  
✔ No food restrictions  
✔ Ideal for working professionals and adults
      `,
    },

    {
      type: "text",
      heading: "Benefits of Orthodontic Treatment",
      content: `
Straightening your teeth is not just about aesthetics — it also improves oral health.

✔ Enhances smile appearance and confidence  
✔ Improves bite and chewing efficiency  
✔ Reduces risk of cavities and gum disease  
✔ Makes oral hygiene easier  
✔ Prevents jaw pain and uneven tooth wear  

A consultation with our experienced orthodontists at Magnum Dental Clinic, Guwahati, will help determine the best option for you.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Braces & Aligners in Guwahati?",
      content: `
✔ Experienced Orthodontists  
✔ Advanced digital smile planning  
✔ Personalized treatment plans  
✔ Modern, hygienic clinic setup  
✔ Affordable pricing and EMI options  
✔ Friendly and supportive care
      `,
    },

    {
      type: "text",
      heading: "Treatment Process",
      content: `
1. Consultation & Scans  
2. Customized Treatment Planning  
3. Placement of Braces or Aligners  
4. Regular Adjustments & Monitoring  
5. Retention Phase for Long-Lasting Results
      `,
    },
  ],

  faqs: [
    {
      q: "Are braces painful?",
      a: "You may feel mild discomfort initially, but it usually subsides within a few days.",
    },
    {
      q: "How long does orthodontic treatment take?",
      a: "Treatment duration varies from 6 months to 2 years, depending on the case.",
    },
    {
      q: "Are clear aligners effective?",
      a: "Yes, aligners are highly effective for mild to moderate alignment issues.",
    },
    {
      q: "Can adults get braces?",
      a: "Absolutely! Orthodontic treatment is suitable for all age groups.",
    },
    {
      q: "How often are follow-up visits needed?",
      a: "Typically once every 3–6 weeks for braces and every 6–8 weeks for aligners.",
    },
  ],

  cta: {
    heading: "Book Your Braces & Aligners Consultation in Guwahati Today",
    description: `
Take the first step toward a straighter, healthier smile with our expert orthodontic care.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Creating Confident Smiles
    `,
    buttonText: "Book Orthodontic Consultation",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
